import React, { Component } from 'react'
import { connect } from 'react-redux'
import IPropTypes from 'react-immutable-proptypes'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import _ from 'lodash'
import cx from 'classnames'

import { LOCALE_PREFIX_SIGNALS } from '../../../Blocks/SyntheticIndicators/constants'

import CustomDate from '../../../../../../../../../../components/CustomDate'

import { NON_PUBLICATION_FINANCIAL_STATEMENTS, CIA_NEWS_CODE, SIGNAL_SCROLL_REFS_MAP } from '../../constants'

import SignalEntity from '../SignalEntity'
import SignalDetail from './components/SignalDetail'
import CheckButton from './components/CheckButton'

import './style.scss'

const mapStateToProps = (state) => ({
    ribbonBlocks: state.getIn(['ui', 'modules', 'report', 'ribbon', 'reportBlocks', 'data']),
})

@connect(mapStateToProps)
export default class Signal extends Component {
    static propTypes = {
        block: PropTypes.string.isRequired,
        customData: PropTypes.object,
        detail: PropTypes.string,
        detailEntities: PropTypes.array,
        label: PropTypes.string.isRequired,
        mainId: PropTypes.string.isRequired,
        module: PropTypes.string.isRequired,
        ownershipDepth: PropTypes.number,
        ownershipPercentage: PropTypes.number,
        properties: PropTypes.object,
        ribbonBlocks: IPropTypes.map,
        scrollTo: PropTypes.func.isRequired,
        scrollRefs: PropTypes.object.isRequired,
        signalsOpenCiaNews: PropTypes.func,
        dateFinancialStatement: PropTypes.object,
        toggleSignalDetail: PropTypes.func.isRequired,
        translates: PropTypes.shape({
            checkDistraints: PropTypes.string.isRequired,
            checkLinkages: PropTypes.string.isRequired,
            detailText: PropTypes.string.isRequired,
        }).isRequired,
        type: PropTypes.string.isRequired,
        openLinkagesById: PropTypes.func,
        setupDistraintsById: PropTypes.func,
    }

    iconIsClickable = () => {
        const { type, ribbonBlocks } = this.props

        // If the signal type is in SIGNAL_SCROLL_REFS_MAP and the block to which the signal refers to is active
        // SIGNAL_SCROLL_REFS_MAP specifies which signal icons should be clickable
        return SIGNAL_SCROLL_REFS_MAP?.[type] && ribbonBlocks.get(SIGNAL_SCROLL_REFS_MAP?.[type])
    }

    handleIconClick = () => {
        const { type, scrollTo, scrollRefs, ribbonBlocks } = this.props

        // If the block to which the signal refers to is active
        if (ribbonBlocks.get(SIGNAL_SCROLL_REFS_MAP?.[type])) {
            scrollTo(scrollRefs[SIGNAL_SCROLL_REFS_MAP?.[type]])
        }
    }

    render() {
        const {
            module,
            block,
            customData,
            type,
            label,
            detailEntities,
            mainId,
            detail,
            ownershipDepth,
            ownershipPercentage,
            properties,
            scrollRefs,
            scrollTo,
            toggleSignalDetail,
            openLinkagesById,
            setupDistraintsById,
            signalsOpenCiaNews,
            dateFinancialStatement,
        } = this.props

        return (
            <div className={'signal'}>
                <div
                    onClick={this.handleIconClick}
                    className={cx('signal-icon', type && type, this.iconIsClickable() && 'clickable')}
                />
                <div className={'signal-content'}>
                    <div className={'signal-label'}>{label}</div>
                    {detailEntities && (
                        <div className={'subjects-wrap'}>
                            {_.map(detailEntities, (entity, entityKey) => (
                                <SignalEntity
                                    key={`signal-entity-${entityKey}`}
                                    module={module}
                                    block={block}
                                    customData={customData}
                                    mainId={mainId}
                                    entity={entity}
                                    type={type}
                                />
                            ))}
                            <div style={{ clear: 'both' }} />
                        </div>
                    )}
                    {type === NON_PUBLICATION_FINANCIAL_STATEMENTS && dateFinancialStatement && (
                        <div className={'signal-financial-statements-container'}>
                            <FormattedMessage
                                id={`${LOCALE_PREFIX_SIGNALS}.dateFinancialStatement`}
                                values={{
                                    year: (
                                        <CustomDate
                                            date={_.get(dateFinancialStatement, 'value', null)}
                                            precision={_.get(dateFinancialStatement, 'precision', 'years')}
                                            returnType="data"
                                        />
                                    ),
                                    b: (chunks) => <b>{chunks}</b>,
                                }}
                            />
                        </div>
                    )}
                    {type === CIA_NEWS_CODE && (
                        <>
                            <div className={'cia-news-signal-counter-row'}>
                                <div className={'counter-wrapper'}>
                                    <span className={'counter yesterday'}>
                                        {properties?.ciaNewsYesterdayNumber ?? 0}
                                    </span>
                                </div>
                                <div className={'description-wrapper'}>
                                    <FormattedMessage id={`${LOCALE_PREFIX_SIGNALS}.ciaNewsYesterdayCount`} />
                                </div>
                            </div>
                            <div className={'cia-news-signal-counter-row'}>
                                <div className={'counter-wrapper'}>
                                    <span className={'counter quarter'}>
                                        {properties?.ciaNewsLast90DaysNumber ?? 0}
                                    </span>
                                </div>
                                <div className={'description-wrapper'}>
                                    <FormattedMessage id={`${LOCALE_PREFIX_SIGNALS}.ciaNews90DaysCount`} />
                                </div>
                            </div>
                        </>
                    )}
                    <CheckButton
                        module={module}
                        block={block}
                        mainId={mainId}
                        type={type}
                        openLinkagesById={openLinkagesById}
                        setupDistraintsById={setupDistraintsById}
                        openCiaNews={signalsOpenCiaNews}
                        scrollRefs={scrollRefs}
                        scrollTo={scrollTo}
                    />
                    {!!ownershipDepth && type === 'RE02' && (
                        <div className={'signal-ownership-depth-container'}>
                            <FormattedMessage
                                id={`${LOCALE_PREFIX_SIGNALS}.ownershipDepth`}
                                values={{ shownVal: ownershipDepth, b: (chunks) => <b>{chunks}</b> }}
                            />
                        </div>
                    )}
                    {
                        // Properties by which ownership depth and interest are determined
                        // are also present in other signals (but they represent other information)
                        // Only show for RE02 (owner in tax haven)
                        !!ownershipPercentage && type === 'RE02' && (
                            <div className={'signal-ownership-percentage-container'}>
                                <FormattedMessage
                                    id={`${LOCALE_PREFIX_SIGNALS}.ownershipPercentage`}
                                    values={{ shownVal: ownershipPercentage, b: (chunks) => <b>{chunks}</b> }}
                                />
                            </div>
                        )
                    }
                </div>
                {detail && (
                    <SignalDetail
                        module={module}
                        block={block}
                        customData={customData}
                        detail={detail}
                        toggleSignalDetail={toggleSignalDetail}
                        type={type}
                        mainId={mainId}
                    />
                )}
            </div>
        )
    }
}
